<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.LOUNGE' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>

		<div class="sidebar__info--flight-info top-gap" *ngIf="!directFlight && stops.length">
			<p>{{ 'whatsIncludedSidebars.text.thisTripHas' | ibeadmin: 'sync' }} {{stops.length}} {{ 'whatsIncludedSidebars.text.flights' | ibeadmin: 'sync' }}. {{ 'whatsIncludedSidebars.detailsLounge.text.chooseForLoungeInfo' | ibeadmin: 'sync' }}</p>
			<app-segmented-control-radio classes="sidebar__info--flight-info--options" (selected)="INDRA_selectedStop($event)"
				[_value]="selectedStop" [options]="stops">
			</app-segmented-control-radio>
		</div>

		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="INDRA_isEligibleWithLounge(), else noAncillary">
		</app-included-per-passenger>

		<ng-template #noAncillary>
			<div class="divider"></div>
			<div class="message_box">
				<app-svg svg="icons.svg#general--information" [alt]="'Information icon'" aria-hidden="true"></app-svg>
				<p>{{ 'whatsIncludedSidebars.detailsLounge.text.loungeNotAvailable' | ibeadmin: 'sync' }}</p>
			</div>
			<div class="divider"></div>
		</ng-template>


		<div class="sidebar-flight-text border">
			<h2 class="title-h2" *ngIf="isEligibleFlag">
				{{ departureLounge }} {{ 'whatsIncludedSidebars.detailsLounge.title.airportLounge' | ibeadmin: 'sync' }}
			</h2>
			<h2 class="title-h2" *ngIf="!isEligibleFlag">
				{{ 'whatsIncludedSidebars.detailsLounge.title.airportLounge' | ibeadmin: 'sync' | titlecase }}
			</h2>
			<p class="muted">
				{{ 'whatsIncludedSidebars.detailsLounge.texts.loungeText' | ibeadmin: 'sync' }}
			</p>
			<p class="muted">
				{{ 'whatsIncludedSidebars.detailsLounge.texts.thereAreSomeThings' | ibeadmin: 'sync' }}
			</p>
			<div class="grid">
				<div class="col-12">
					<ul>
						<li *ngFor="let items of loungeItems">{{items}}</li>
						
					</ul>
				</div>
			</div>
			<a (click)="INDRA_gotoURL('externalURLs.aboutLounge')"
				href="javascript:;"
				class="link extras-feature__link link--external" 
				aria-label="Open All about lounge, opens new window">
				{{ 'whatsIncludedSidebars.detailsLounge.title.allAboutLounge' | ibeadmin: 'sync' }}
			</a>
		</div>

		<app-compare-brands [feature]="feature" [brand]="brand" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>
		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					aria-label="Close dialog"
					(click)="INDRA_handleClose()" 
					href="javascript:;" 
					role="button">
					{{ 'whatsIncludedSidebars.general.text.closeWindow' | ibeadmin: 'sync' }}
				</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
